export default __webpack_public_path__ + "static/media/016-singer.e6483e59.svg";